/**
 * 亚马逊新闻卡片组件
 */

import React from 'react';
import { Card, Button, Space, Segmented, Tooltip, Spin, Tag, Empty, Typography } from 'antd';
import { ReloadOutlined, GlobalOutlined, RightOutlined, FireOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import type { AmazonNewsItem } from '../../services/dashboardService';
import { getCategoryInfo } from './constants';

const { Text } = Typography;

interface AmazonNewsCardProps {
    news: AmazonNewsItem[];
    newsRegion: 'all' | 'cn' | 'us';
    onRegionChange: (region: 'all' | 'cn' | 'us') => void;
    onRefresh: () => void;
    loading: boolean;
    updatedAt: string;
}

export const AmazonNewsCard: React.FC<AmazonNewsCardProps> = ({
    news,
    newsRegion,
    onRegionChange,
    onRefresh,
    loading,
    updatedAt,
}) => {
    return (
        <Card
            className="dashboard-card amazon-news-card"
            title={
                <div className="news-card-header">
                    <div className="news-title-wrap">
                        <FireOutlined className="news-fire-icon" />
                        <span>亚马逊官方公告</span>
                    </div>
                    <div className="news-controls">
                        <Segmented
                            size="small"
                            value={newsRegion}
                            onChange={(val) => onRegionChange(val as 'all' | 'cn' | 'us')}
                            options={[
                                { label: '全部', value: 'all' },
                                { label: '🇨🇳 中国', value: 'cn' },
                                { label: '🇺🇸 美国', value: 'us' },
                            ]}
                        />
                        <Tooltip title="刷新">
                            <Button
                                type="text"
                                size="small"
                                icon={<ReloadOutlined spin={loading} />}
                                onClick={onRefresh}
                                style={{ marginLeft: 8 }}
                            />
                        </Tooltip>
                    </div>
                </div>
            }
        >
            {loading ? (
                <div className="news-loading">
                    <Spin />
                </div>
            ) : news.length > 0 ? (
                <div className="news-list">
                    {news.slice(0, 10).map((item, index) => {
                        const catInfo = getCategoryInfo(item.category);
                        return (
                            <a
                                key={index}
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="news-item"
                            >
                                <div className="news-item-icon">{item.icon}</div>
                                <div className="news-item-content">
                                    <div className="news-item-title">{item.title}</div>
                                    <div className="news-item-meta">
                                        <Tag
                                            style={{
                                                background: catInfo.bgColor,
                                                color: catInfo.color,
                                                border: 'none',
                                                fontSize: 11,
                                                borderRadius: 4,
                                                padding: '1px 6px'
                                            }}
                                        >
                                            {catInfo.text}
                                        </Tag>
                                        <Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
                                            {item.source}
                                        </Text>
                                        {item.time && (
                                            <Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
                                                {item.time}
                                            </Text>
                                        )}
                                    </div>
                                </div>
                                <RightOutlined className="news-item-arrow" />
                            </a>
                        );
                    })}
                </div>
            ) : (
                <Empty description="暂无公告" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            {updatedAt && (
                <div className="news-footer">
                    <Text type="secondary" style={{ fontSize: 11 }}>
                        <GlobalOutlined style={{ marginRight: 4 }} />
                        更新时间: {dayjs(updatedAt).format('YYYY-MM-DD HH:mm')}
                    </Text>
                </div>
            )}
        </Card>
    );
};

export default AmazonNewsCard;
